import { Schema } from "mongoose"
import { z } from "zod"


export const ZRBTenantSubscriptionStatus = z.enum([
  "trialing",
  "active",
  "past_due",
  "paused",
  "canceled",
  "expired",
])

export const ZRBTenantSubscriptionIntervalUnit = z.enum(["month", "year"])


export const ZRBTenantSubscriptionEventSource = z.enum([
  "admin",
  "system",
  "webhook",
  "user",
])

export const ZRBTenantSubscriptionChangeDirection = z.enum([
  "upgrade",
  "downgrade",
  "lateral",
])

export const ZRBTenantSubscriptionEvent = z.object({
  tenantId: z.string(),
  subscriptionId: z.string(),
  type: z.string(),
  occurredAt: z.date(),
  effectiveAt: z.date().optional(),
  fromPlanKey: z.string().optional(),
  toPlanKey: z.string().optional(),
  fromStatus: ZRBTenantSubscriptionStatus.optional(),
  toStatus: ZRBTenantSubscriptionStatus.optional(),
  fromModules: z.array(z.string()).optional(),
  toModules: z.array(z.string()).optional(),
  fromIntervalUnit: ZRBTenantSubscriptionIntervalUnit.optional(),
  toIntervalUnit: ZRBTenantSubscriptionIntervalUnit.optional(),
  fromIntervalCount: z.number().int().min(1).optional(),
  toIntervalCount: z.number().int().min(1).optional(),
  direction: ZRBTenantSubscriptionChangeDirection.optional(),
  actorUserId: z.string().optional(),
  source: ZRBTenantSubscriptionEventSource.optional(),
  reason: z.string().optional(),
  provider: z.string().optional(),
  providerEventId: z.string().optional(),
  providerPayload: z.unknown().optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
})

export type IRBTenantSubscriptionEvent = z.infer<typeof ZRBTenantSubscriptionEvent>

export const RBTenantSubscriptionEventSchema: Schema = new Schema(
  {
    tenantId: { type: String, required: true, index: true },
    subscriptionId: { type: String, required: true, index: true },
    type: { type: String, required: true },
    occurredAt: { type: Date, required: true, default: Date.now },
    effectiveAt: { type: Date },
    fromPlanKey: { type: String },
    toPlanKey: { type: String },
    fromStatus: { type: String, enum: ZRBTenantSubscriptionStatus.options },
    toStatus: { type: String, enum: ZRBTenantSubscriptionStatus.options },
    fromModules: { type: [String], default: undefined },
    toModules: { type: [String], default: undefined },
    fromIntervalUnit: { type: String, enum: ZRBTenantSubscriptionIntervalUnit.options },
    toIntervalUnit: { type: String, enum: ZRBTenantSubscriptionIntervalUnit.options },
    fromIntervalCount: { type: Number, min: 1 },
    toIntervalCount: { type: Number, min: 1 },
    direction: { type: String, enum: ZRBTenantSubscriptionChangeDirection.options },
    actorUserId: { type: String },
    source: { type: String, enum: ZRBTenantSubscriptionEventSource.options },
    reason: { type: String },
    provider: { type: String },
    providerEventId: { type: String },
    providerPayload: { type: Schema.Types.Mixed },
    metadata: { type: Schema.Types.Mixed },
  },
)

RBTenantSubscriptionEventSchema.index({ tenantId: 1, subscriptionId: 1, occurredAt: 1 })
RBTenantSubscriptionEventSchema.index({ provider: 1, providerEventId: 1 }, { unique: true, sparse: true })
